export default {
  title: 'dark',

  colors: {
    background: '#222',
    text: '#eee',
    repoBackground: '#333',
  },
};
